<body class="theme-color-2">

    <!-- Breadcrumb Section Start -->
    <section class="breadcrumb-section pt-0">
        <div class="container-fluid-lg">
            <div class="row">
                <div class="col-12">
                    <div class="breadcrumb-contain">
                        <!-- <h2>{{ DataList.product_name }}</h2> -->
                        <h2>
                            <li class="breadcrumb-item">
                                <a [routerLink]="['/']">
                                    <i class="fa-solid fa-house"></i>
                                </a>
                            </li>

                            <li class="breadcrumb-item active">{{ DataList.product_name }}
                            </li>
                        </h2>
                        <nav>
                            <ol class="breadcrumb mb-0">

                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- Breadcrumb Section End -->

    <!-- Product Left Sidebar Start -->
    <section class="product-section pb-5">
        <div class="container-fluid-lg">
            <div class="row">
                <div class="col-xxl-12 col-xl-12 col-lg-12 wow fadeInUp">
                    <div class="row g-4">
                        <div class="col-xl-6 wow fadeInUp">
                            <div class="product-left-box">
                                <div class="row g-2">
                                    <div class="col-xxl-12 col-lg-12 col-md-12">
                                        <div class="product-main-2 no-arrow">
                                            <div>
                                                <div class="slider-image zoom-container" (mousemove)="zoomImage($event)" (mouseleave)="hideLens()">

                                                    <img [src]="firstVariationImagePath ? imageBaseUrl + firstVariationImagePath : domiImageBaseUrl" alt="Product Image" class="img-fluid image_zoom_cls-0 blur-up main-image" #image />
                                                    <div class="lens" #lens></div>
                                                </div>
                                                <!-- <div class="slider-image zoom-container mainImage" #mainImageWrapper (mousemove)="onMouseMove($event)" (mouseleave)="onMouseLeave()">
                                                    <img [src]="firstVariationImagePath ? imageBaseUrl + firstVariationImagePath : domiImageBaseUrl" alt="Product Image" class="img-fluid image_zoom_cls-0 blur-up main-image" #mainImage />
                                                    <div class="lens" #lens></div>
                                                </div> -->
                                            </div>

                                        </div>
                                    </div>

                                    <div class="col-xxl-12 col-lg-12 col-md-12">
                                        <div class="slider-container">
                                            <div class="primary_slider">

                                                <div id="primary_slider" class="splide">
                                                    <div class="splide__track">
                                                        <ul class="splide__list">
                                                            <!-- <li class="splide__slide" *ngFor="let image of primaryImages">
                                                              <img [src]="image" alt="Slider Image">
                                                          </li> -->
                                                            <li class="splide__slide" *ngFor="let productImage of filteredVariation">

                                                                <img [src]="productImage.image_path ? imageBaseUrl + productImage.image_path : domiImageBaseUrl" alt="Product Image" (click)="ImageUrls(productImage.image_path)" />

                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                        <div class="left-slider-image-2 left-slider no-arrow slick-top">

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-xl-6 wow fadeInUp" data-wow-delay="0.1s">
                            <div class="right-box-contain">
                                <!-- <h6 class="offer-top">30% Off</h6> -->
                                <h2 class="name">{{ DataList.product_name ||''}}</h2>
                                <!-- <div class="price-rating" *ngIf="filteredVariation.discount_price; else variationPrice">
                                <h3 class="theme-color price">₹{{ filteredVariation.discount_price }}</h3>
                            </div>

                            <ng-template #variationPrice>
                                <div class="price-rating" *ngIf="filteredVariation.variations_price; else defaultSellingPrice">
                                    <h3 class="theme-color price">₹{{ filteredVariation.variations_price }}</h3>
                                </div>
                            </ng-template>

                            <ng-template #defaultSellingPrice>
                                <div class="price-rating" *ngIf="DataList.discount_price; else defaultDiscountPrice">
                                    <h3 class="theme-color price">₹{{ DataList.discount_price }}
                                    </h3>
                                </div>
                            </ng-template>

                            <ng-template #defaultDiscountPrice>
                                <div class="price-rating">
                                    <h3 class="theme-color price">₹{{ DataList.selling_price }}
                                    </h3>
                                </div>
                            </ng-template> -->
                                <div class="price-rating">
                                    <h3 class="theme-color price">
                                        <ng-container *ngIf="percentage > 0; else noOffer">
                                            ₹{{ price - (price * percentage / 100) }}
                                            <del class="color">₹{{ price || "" }}</del>
                                        </ng-container>
                                    </h3>
                                    <ng-template #noOffer>
                                        <h3 class="theme-color price">₹{{ price || '' }}</h3>
                                    </ng-template>
                                </div>
                                <div class="product-contain">
                                    <p>{{ DataList.short_description }}</p>
                                </div>

                                <div class="product-package" *ngFor="let attributeData of DataList?.attributeTermData">
                                    <div class="product-title">
                                        <h4>{{ attributeData.name }}</h4>
                                    </div>
                                    <ul class="select-package">
                                        <li *ngFor="let termData of attributeData.terms">
                                            <a href="javascript:void(0)" [ngClass]="{ 'active': activeTerms[attributeData.id] === termData.id }" (click)="setActiveTerm(attributeData.id, termData.id)">
                        {{ termData.name }}
                      </a>
                                        </li>
                                    </ul>
                                </div>
                                <div class="note-box product-package">
                                    <div *ngIf="DataList?.product_stock == 0 || !price ||  filteredVariationData.stock == 0; else inStock">
                                        <p>Product out of stock</p>
                                        <br>
                                        <button (click)="notifyMe() " class="btn btn-md bg-dark cart-button text-white w-100">
                      <h6 *ngIf="!IsnotifyMe"><i data-feather="bell"></i>&nbsp;
                        Notify me</h6>
                      <h6 *ngIf="IsnotifyMe"
                        class="spinner-border spinner-border-sm spinner-grow flex-shrink-0"
                        role="status" aria-hidden="true">

                      </h6>
                    </button>
                                    </div>
                                    <ng-template #inStock>
                                        <!-- If DataList.cart is available, show this block -->
                                        <div class="cart_qty qty-box product-qty" *ngIf="DataList?.cart; else notaddQty">
                                            <div class="input-group">
                                                <button type="button" (click)="updateQuantity('minus', DataList?.id,cartQuantity,cartPrice)" class="qty-left-minus" data-type="minus" data-field>
                          <i class="fa fa-minus"></i>
                        </button>
                                                <input class="form-control input-number qty-input" readonly type="text" name="cartQuantity" [value]="cartQuantity">
                                                <button type="button" class="qty-right-plus" (click)="updateQuantity('plus', DataList?.id,cartQuantity,cartPrice)" data-type="plus" data-field>
                          <i class="fa fa-plus"></i>
                        </button>
                                            </div>
                                        </div>

                                        <!-- This will be shown if DataList.cart is not available -->
                                        <ng-template #notaddQty>
                                            <div class="cart_qty qty-box product-qty">
                                                <div class="input-group">
                                                    <button type="button" (click)="plusMinusQuantity('minus')" class="qty-left-minus" data-type="minus" data-field>
                            <i class="fa fa-minus"></i>
                          </button>
                                                    <input class="form-control input-number qty-input" readonly type="text" name="quantity" [value]="quantity">
                                                    <button type="button" class="qty-right-plus" (click)="plusMinusQuantity('plus')" data-type="plus" data-field>
                            <i class="fa fa-plus"></i>
                          </button>
                                                </div>
                                            </div>
                                        </ng-template>

                                        <span *ngIf="DataList?.cart else goToCart">
                      <button matTooltip="Click me to for view cart!"
                        [routerLink]=" [ '/users/account/cart'] "
                        routerLinkActive="active-link-class"
                        class="btn btn-md bg-dark cart-button text-white w-100">
                        Go To Cart
                      </button>
                    </span>
                                        <ng-template #goToCart>

                                            <button (click)="addToCart() " class="btn btn-md bg-dark cart-button text-white w-100">
                        <span *ngIf="!isCartLoading">Add To Cart</span>
                        <span *ngIf="isCartLoading"
                          class="spinner-border spinner-border-sm spinner-grow flex-shrink-0"
                          role="status" aria-hidden="true">
                          <p> </p>
                        </span>
                      </button>

                                        </ng-template>
                                        <!-- <button [routerLink]="['/users/account/checkout' ,encryptId(product_id),encryptId(quantity),encryptId(variationsCodeToFilter),encryptId('buynow')]" class="btn theme-bg-color text-white btn-md w-100 fw-bold ">
                      Buy Now
                    </button> -->
                                        <button (click)="buyNowstock(product_id,quantity,variationsCodeToFilter)" class="btn theme-bg-color text-white btn-md w-100 fw-bold ">
                      Buy Now
                    </button>

                                    </ng-template>
                                </div>

                                <!-- <div class="progress-sec" *ngIf="DataList?.product_stock != 0 && price &&  filteredVariationData.stock != 0">
                                  <div class="left-progressbar ">
                                      <h6>Please hurry! Only 5 left in stock
                                      </h6>
                                      <div role="progressbar " class="progress warning-progress ">
                                          <div class="progress-bar progress-bar-striped progress-bar-animated " style="width: 50%; "></div>
                                      </div>
                                  </div>
                              </div> -->
                                <button (click)="shareProduct()" aria-label="Share Product" class="svr_share_btn">
                  <span>Share this product:</span>
                  <svg matTooltip="Click me to share this product" width="24" height="24" viewBox="0 0 24 24" fill="green"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M18 16.08C17.24 16.08 16.56 16.38 16.05 16.88L8.91 12.7C8.96 12.47 9 12.24 9 12C9 11.76 8.96 11.53 8.91 11.3L15.96 7.11C16.5 7.61 17.21 7.94 18 7.94C19.66 7.94 21 6.6 21 4.94C21 3.28 19.66 1.94 18 1.94C16.34 1.94 15 3.28 15 4.94C15 5.18 15.04 5.41 15.09 5.64L8.04 9.83C7.5 9.33 6.79 9 6 9C4.34 9 3 10.34 3 12C3 13.66 4.34 15 6 15C6.79 15 7.5 14.67 8.04 14.17L15.14 18.37C15.09 18.59 15.06 18.83 15.06 19.07C15.06 20.73 16.4 22.07 18.06 22.07C19.72 22.07 21.06 20.73 21.06 19.07C21.06 17.41 19.72 16.08 18.06 16.08Z" />
                  </svg>
                </button>
                                <!-- <div class="share-popup" *ngIf="isPopupVisible">
                                    <div class="popup-header">
                                        <span class="close-icon" (click)="closePopup()">×</span>
                                        <h3>Share Product</h3>
                                    </div>
                                    <div class="popup-body">
                                        <button (click)="shareProduct()">Share via Device</button>
                                    </div>
                                </div> -->
                                <div class="buy-box ">
                                    <a routerLink="/users/account/wishlist-list" matTooltip="Click me to for view wishlist!" *ngIf="DataList?.wishlist; else addWishList">
                                        <span class>
                      <!-- <i class="active-heart" data-feather="heart"></i> -->
                      <svg width="24" height="24" viewBox="0 0 24 24"
                        fill="green">
                        <path
                          d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
                      </svg>
                      Go to Wishlist</span>
                                    </a>
                                </div>

                                <ng-template #addWishList>
                                    <a class="pointer">
                                        <span (click)="addToWishlistdetail()">
                      <i data-feather="heart">
                      </i>
                      Add To Wishlist</span></a>
                                </ng-template>

                                <!-- <div class="payment-option ">
                                    <div class="product-title ">
                                        <h4>Guaranteed Safe Checkout</h4>
                                    </div>
                                    <ul>
                                        <li>
                                            <a href="javascript:void(0) ">
                                                <img src="assets/images/product/payment/1.svg " class="blur-up lazyload " alt>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="javascript:void(0) ">
                                                <img src="assets/images/product/payment/2.svg " class="blur-up lazyload " alt>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="javascript:void(0) ">
                                                <img src="assets/images/product/payment/3.svg " class="blur-up lazyload " alt>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="javascript:void(0) ">
                                                <img src="assets/images/product/payment/4.svg " class="blur-up lazyload " alt>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="javascript:void(0) ">
                                                <img src="assets/images/product/payment/5.svg " class="blur-up lazyload " alt>
                                            </a>
                                        </li>
                                    </ul>
                                </div> -->
                            </div>
                        </div>

                        <div class="col-12">
                            <div class="product-section-box">
                                <ul class="nav nav-tabs custom-nav" id="myTab" role="tablist">
                                    <li class="nav-item" role="presentation">
                                        <button class="nav-link active" id="description-tab" data-bs-toggle="tab" data-bs-target="#description" type="button" role="tab">Description</button>
                                    </li>

                                    <li class="nav-item" role="presentation">
                                        <button class="nav-link" id="info-tab" data-bs-toggle="tab" data-bs-target="#info" type="button" role="tab">Additional
                      info</button>
                                    </li>

                                    <!-- <li class="nav-item" role="presentation">
                                      <button class="nav-link" id="care-tab" data-bs-toggle="tab" data-bs-target="#care" type="button" role="tab">Care
                                        Instructions</button>
                                  </li> -->
                                </ul>

                                <div class="tab-content custom-tab" id="myTabContent">
                                    <div class="tab-pane fade show active" id="description" role="tabpanel">
                                        <div class="product-description">
                                            <!-- <div class="nav-desh">
                                              <p>Jelly beans carrot cake icing biscuit oat cake gummi bears tart. Lemon drops carrot cake pudding sweet gummi bears. Chocolate cake tart cupcake donut topping liquorice sugar plum chocolate bar. Jelly beans
                                                  tiramisu caramels jujubes biscuit liquorice chocolate. Pudding toffee jujubes oat cake sweet roll. Lemon drops dessert croissant danish cake cupcake. Sweet roll candy chocolate toffee jelly sweet roll
                                                  halvah brownie topping. Marshmallow powder candy sesame snaps jelly beans candy canes marshmallow gingerbread pie.</p>
                                          </div> -->

                                            <div class="nav-desh">
                                                <div class="desh-title">
                                                    <h5>Important Note:</h5>
                                                </div>
                                                <p>
                                                    <!-- vitae et leo duis ut diam quam nulla porttitor massa id neque aliquam vestibulum morbi blandit cursus risus at ultrices mi tempus imperdiet nulla malesuada pellentesque elit eget gravida cum sociis natoque
                                                  penatibus et magnis dis parturient montes nascetur ridiculus mus mauris vitae ultricies leo integer malesuada nunc vel risus commodo viverra maecenas accumsan lacus vel facilisis volutpat est velit egestas
                                                  dui id ornare arcu odio ut sem nulla pharetra diam sit amet nisl suscipit adipiscing bibendum est ultricies integer quis auctor elit sed vulputate mi sit amet mauris commodo quis imperdiet massa tincidunt
                                                  nunc pulvinar sapien et ligula ullamcorper malesuada proin libero nunc consequat interdum varius sit amet mattis vulputate enim nulla aliquet porttitor lacus luctus accumsan.
                                                 -->
                                                    <p>{{ DataList.important_note || "NUN" }}
                                                    </p>
                                            </div>

                                            <!-- <div class="banner-contain nav-desh">
                                              <img src="assets/images/banner/1.png" class="bg-img blur-up lazyload" alt="">
                                              <div class="banner-details p-center banner-b-space w-100 text-center">
                                                  <div>
                                                      <h6 class="ls-expanded theme-color mb-sm-3 mb-1">SUMMER</h6>
                                                      <h2>VEGETABLE</h2>
                                                      <p class="mx-auto mt-1">Save up to 5% OFF</p>
                                                  </div>
                                              </div>
                                          </div> -->

                                            <div class="nav-desh">
                                                <div class="desh-title">
                                                    <h5>Description:</h5>
                                                </div>
                                                <p>
                                                    <!-- Jelly beans shortbread chupa chups carrot cake jelly-o halvah apple pie pudding gingerbread. Apple pie halvah cake tiramisu shortbread cotton candy croissant chocolate cake. Tart cupcake caramels gummi bears
                                                  macaroon gingerbread fruitcake marzipan wafer. Marzipan dessert cupcake ice cream tootsie roll. Brownie chocolate cake pudding cake powder candy ice cream ice cream cake. Jujubes soufflé chupa chups
                                                  cake candy halvah donut. Tart tart icing lemon drops fruitcake apple pie. -->
                                                    {{ DataList.long_description | removeHtml }}
                                                </p>

                                            </div>
                                        </div>
                                    </div>

                                    <div class="tab-pane fade" id="info" role="tabpanel">
                                        <div class="table-responsive">
                                            <table class="table info-table">
                                                <tbody>

                                                    <tr>
                                                        <td>Weight</td>
                                                        <td> {{ DataList.weight_value? DataList.weight_value: "-"}} {{ DataList.weight_value? DataList.weight_unit: ""}}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td> Length</td>

                                                        <td>{{ DataList.product_length? DataList.product_length: "-"}} {{ DataList.product_length? 'CM': ""}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td> Width</td>

                                                        <td> {{ DataList.product_width? DataList.product_width: "-"}} {{ DataList.product_width? 'CM': ""}}</td>
                                                    </tr>

                                                    <tr>
                                                        <td> Height</td>

                                                        <td> {{ DataList.product_height? DataList.product_height: "-"}} {{ DataList.product_height? 'CM': ""}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Most popular</td>
                                                        <td> {{ DataList.popular_status? 'Yes' : 'No' }}
                                                        </td>
                                                    </tr>

                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                    <div class="tab-pane fade" id="care" role="tabpanel">
                                        <div class="information-box">
                                            <ul>
                                                <li>Store cream cakes in a refrigerator. Fondant cakes should be stored in an air conditioned environment.
                                                </li>

                                                <li>Slice and serve the cake at room temperature and make sure it is not exposed to heat.</li>

                                                <li>Use a serrated knife to cut a fondant cake.</li>

                                                <li>Sculptural elements and figurines may contain wire supports or toothpicks or wooden skewers for support.
                                                </li>

                                                <li>Please check the placement of these items before serving to small children.</li>

                                                <li>The cake should be consumed within 24 hours.</li>

                                                <li>Enjoy your cake!</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- Product Left Sidebar End -->
    <!-- Product Section Start -->
    <section class="pb-md-5 product-section">
        <!--
<div class="container-fluid-lg ">

</div> -->

        <div class="container-fluid-lg loader" *ngIf="!isLoading && similarProductDataList.length">
            <h2>Similar Products</h2>
            <br>
            <div class="row " *ngIf="isLoading">
                <div class="col-12 d-flex justify-content-center ">
                    <div class="spinner-border text-success" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                </div>
            </div>

            <div class="row">
                <div *ngFor="let product of similarProductDataList" class="product-card" class="col-lg-2 col-md-4 col-sm-6 pb-10">
                    <div class="product-box-4">
                        <div class="product-image">
                            <div class="label-flex">
                                <div *ngIf="product.popular_status == 1" class="discount">
                                    <label>Most Popular</label>
                                </div>
                                <button *ngIf="product?.wishlist; else addWishList " class="btn p-0 wishlist btn-wishlist notifi-wishlist " (click)="removeToWishlist(product.id)">
                    <!-- <i class="iconly-Heart icli"
                matTooltip="Click me to for view wishlist!"></i> -->
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="green"
                      matTooltip="Remove for wishlist!">
                      <path
                        d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
                    </svg>
                  </button>

                                <ng-template #addWishList>
                                    <!-- <button class="btn p-0 wishlist btn-wishlist notifi-wishlist">
                <i (click)="addToWishlist(product.id)"
                  class="iconly-Heart icli"></i>
              </button> -->
                                </ng-template>
                            </div>

                            <ng-container>
                                <!-- First condition -->
                                <ng-container *ngIf="product.product_type == 0; else checkVariation">
                                    <a class="pointer" (click)="navigateToProductDetail(product.id, product.product_slug,'0')">
                                        <img [src]="imageBaseUrl + product.product_thumbnail ? imageBaseUrl + product.product_thumbnail : domiImageBaseUrl" class="img-fluid" alt />

                                    </a>
                                </ng-container>

                                <!-- Second condition -->
                                <ng-template #checkVariation>
                                    <ng-container *ngIf="product.variations?.image?.image_path; else defaultThumbnail">
                                        <a class="pointer" (click)="navigateToProductDetail(product.id, product.product_slug,product.variations.variations_code)">
                                            <img [src]="imageBaseUrl + product.variations.image.image_path ? imageBaseUrl + product.variations.image.image_path : domiImageBaseUrl" class="img-fluid" alt />
                                        </a>
                                    </ng-container>
                                </ng-template>

                                <!-- Default condition -->
                                <ng-template #defaultThumbnail>

                                    <a class="pointer" *ngIf="product.variations.variations_code; else defaultvariations" (click)="navigateToProductDetail(product.id, product.product_slug,product.variations.variations_code)">
                                        <img [src]="imageBaseUrl + product.product_thumbnail ? imageBaseUrl + product.product_thumbnail : domiImageBaseUrl" class="img-fluid" alt />
                                    </a>

                                    <ng-template #defaultvariations>

                                        <a class="pointer" (click)="navigateToProductDetail(product.id, product.product_slug,'0')">
                                            <img [src]="imageBaseUrl + product.product_thumbnail ? imageBaseUrl + product.product_thumbnail : domiImageBaseUrl" class="img-fluid" alt />
                                        </a>

                                    </ng-template>
                                </ng-template>
                            </ng-container>
                        </div>

                        <div class="product-detail">
                            <a>
                                <h5 class="name">{{ product.product_name || "" }}</h5>
                            </a>
                            <div>

                                <ng-container *ngIf="product.product_type == 0 ; else notVariation">
                                    <h5 class="price theme-color">
                                        ₹{{ product.discount_price || product.selling_price}}
                                    </h5>
                                </ng-container>
                                <ng-template #notVariation>
                                    <h5 class="price theme-color">
                                        ₹{{ product.variations.discount_price|| product.variations.variations_price}}
                                    </h5>
                                </ng-template>

                            </div>

                            <!-- Show 'Out of Stock' if product_stock is 0 or variations.stock is unavailable -->
                            <div class="price-qty" *ngIf="product?.product_stock == 0 || (product.variations?.stock == '0'); else inStock">
                                <p>Out of Stock</p>
                            </div>

                            <!-- In-Stock Template -->
                            <ng-template #inStock>
                                <!-- Show 'Go to Cart' if product is already in the cart -->
                                <span *ngIf="product?.cart; else addToCart">
                    <button class="buy-button buy-button-2 btn svr_GotoCart">

                      <i class="fa fa-eye icli text-white m-0"
                        [routerLink]="['/users/account/cart']"
                        matTooltip="Click me to for view cart!"></i>

                    </button>
                  </span>

                                <!-- Template for "Add to Cart" -->
                                <ng-template #addToCart>

                                    <!-- <button *ngIf="product.product_type == 1 ;else variantCart" (click)="openModal(product)" class="buy-button buy-button-2 btn">
                <i class="iconly-Buy icli text-white m-0"></i>
              </button>

              <ng-template #variantCart>
                  <button (click)="addToCartData(product.id, 1, product.variations? product.variations.discount_price || product.variations.variations_price : product.discount_price?  product.discount_price:product.selling_price, product.product_type, product.variations ? product.variations.id : '')"
                      class="buy-button buy-button-2 btn">
                  <i class="iconly-Buy icli text-white m-0"></i>
                </button>
              </ng-template> -->

                                </ng-template>
                            </ng-template>

                        </div>
                    </div>
                </div>
                <!-- <div id="myModal" class="modal" [ngClass]="{'show': isModalOpen}" (click)="closeModal($event)">


          <div class="modal-content" (click)="stopPropagation($event)">
              <div class="modal-header">
                  <h2>Product Details</h2>
                  <span class="close" (click)="closeModal($event)">&times;</span>

              </div>
              <div class="modal-body">
                  <div class="product-section">
                      <div class="right-box-contain">
                          <div class="note-box product-package">

                              <div class="product-package-img">
                                  <img [src]="imageBaseUrl + firstVariationImagePath ? imageBaseUrl + firstVariationImagePath : domiImageBaseUrl" class="img-fluid" alt />
                              </div>
                              <div class="product-package-info">
                                  <div class="price-rating">
                                      <div class="theme-color price">
                                          <h3>₹{{ price ||'' }}</h3>
                                      </div>
                                  </div>
                                  <div class="product-package" *ngFor="let attributeData of attrVariationDataList?.attributeTermData">
                                      <div class="product-title">
                                          <h4>{{ attributeData.name }}</h4>
                                      </div>
                                      <ul class="select-package">
                                          <li *ngFor="let termData of attributeData.terms">
                                              <a href="javascript:void(0)" [ngClass]="{ 'active': activeTerms[attributeData.id] === termData.id }" (click)="setActiveTerms(attributeData.id, termData.id)">
                          {{ termData.name }}
                        </a>
                                          </li>
                                      </ul>

                                  </div>
                                  <div class="product-qty-box">
                                      <div class="cart_qty qty-box product-qty">
                                          <div class="input-group">
                                              <button type="button" (click)="plusMinusQuantity('minus')" class="qty-left-minus" data-type="minus" data-field>
                          <i class="fa fa-minus"></i>
                        </button>
                                              <input class="form-control input-number qty-input" type="text" name="quantity" value="{{ quantity }}">
                                              <button type="button" (click)="plusMinusQuantity('plus')" class="qty-right-plus" data-type="plus" data-field>
                          <i class="fa fa-plus"></i>
                        </button>
                                          </div>
                                      </div>
                                      <button (click)="addToCartData(product.id, quantity,price, product.product_type, variant_id ? variant_id : '')" class="btn btn-md bg-dark cart-button text-white w-100">
                      <span *ngIf="!isCartLoading">Add To Cart</span>
                      <span *ngIf="isCartLoading"
                        class="spinner-border spinner-border-sm spinner-grow flex-shrink-0"
                        role="status" aria-hidden="true">
                        <p> Loading..</p></span>

                    </button>
                                  </div>

                              </div>
                          </div>

                      </div>
                  </div>
              </div>

          </div>

          <button type="submit" class="btn btn-animation">
      </button>


      </div> -->
            </div>

        </div>
    </section>
    <!-- Product Section End -->
</body>
